/**
 * POSSIBLE AUTO GENERATED BY @graphql-codegen/fragment-matcher DO NOT MODIFY DIRECTLY. SEE GQL-GEN/CONFIG
 */


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Certificate": [
      "CertificateText",
      "CertificateUrl"
    ],
    "SearchResults": [
      "ContentDocumentSearchResponse",
      "GeneSearchResults",
      "PaperSearchResponse",
      "ProductSearchResults"
    ],
    "SearchResultsItems": [
      "Gene",
      "Paper",
      "Product",
      "Substance",
      "TechnicalDocument"
    ],
    "User": [
      "GuestUser",
      "LoggedInUser"
    ]
  }
};
      export default result;
    